/*
 * Copyright (c) 2023. Collabro Limited
 */

import React, { memo } from "react";
import { FormControl, InputLabel, Select } from "@mui/material";
import { Location } from "SearchParameters";

interface DropdownComponent {
  label: string;
  value: Location | null;
  setter: any;
  children: any;
  multiple?: boolean;
}

const Dropdown = ({
  label,
  value,
  children,
  setter,
  multiple = false,
}: DropdownComponent) => {
  const handleChange = (e: any) => {
    console.log(e);
    setter(e.target.value);
  };

  return (
    <FormControl fullWidth size="small">
      <InputLabel id={`parameters-${label}-select-label`}>{label}</InputLabel>
      <Select
        labelId={`parameters-${label}-select-label`}
        size="small"
        id={`parameters-${label}-select`}
        value={value ? value : "None"}
        label={label}
        multiline={multiple}
        maxRows={2}
        multiple={multiple}
        onChange={handleChange}
      >
        {children}
      </Select>
    </FormControl>
  );
};

const propsAreEqual = (prev: any, next: any) => {
  return prev.value === next.value;
};

export default memo(Dropdown, propsAreEqual);
